import React, { FC } from 'react';
import styled from 'styled-components';
import PremiumSubscribeButton, { PremiumSubscribeButtonType } from './PremiumSubscribeButton';

import themes from 'themes';
import { translations } from 'i18n';

import premiumLogo from '../../../icons/premium-logo.svg';

interface PremiumCollectionHeaderProps {
  userHasGalleryGrant: boolean;
  subscribeButtonTrigger?: string;
}

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 15px;
`;

const PremiumLabel = styled.div`
  background: url(${premiumLogo}) center center / contain no-repeat;
  width: 12px;
  height: 12px;
  margin-right: 6px;
`;

const PremiumText = styled.div`
  font-size: 14px;
  line-height: 20px;
  letter-spacing: -0.15px;
  color: ${themes.fitbitPremiumYellow};
`;

const LeftContainer = styled.div`
  display: flex;
  align-items: center;
`;

const PremiumCollectionHeader: FC<PremiumCollectionHeaderProps> = ({
  userHasGalleryGrant,
  subscribeButtonTrigger = 'premium-collection'
}) => (
  <Container>
    <LeftContainer>
      <PremiumLabel />
      <PremiumText>
        {userHasGalleryGrant
          ? translations.premium.includedWithPremium()
          : translations.premium.availableOnlyToPremium()
        }
      </PremiumText>
    </LeftContainer>
    {!userHasGalleryGrant && <PremiumSubscribeButton
      trigger={subscribeButtonTrigger}
      type={PremiumSubscribeButtonType.TEXT}
    />}
  </Container>
);

export default PremiumCollectionHeader;
